// extracted by mini-css-extract-plugin
export default {"title":"projects_title__Bbwfo","right":"projects_right__KC3+J","boxesWrapper":"projects_boxesWrapper__7AYsn"};